export default "__VITE_ASSET__BxXMRRQc__"